module.exports = __webpack_public_path__ + "img/smart-home.8b980f16.png";